import React from 'react';
import { MessageSquareIcon, AlertTriangleIcon, RefreshCwIcon, ArrowLeftIcon } from 'lucide-react';
import { ScreenProps } from '../../types/ptp';
import { PrimaryButton } from '../ui/PrimaryButton';
import { SecondaryButton } from '../ui/SecondaryButton';
export function Screen17_FullReview({
  data,
  onBack,
  onNext
}: ScreenProps) {
  const crewRoles = data.crewRoles || [];
  const steps = data.stepHazardData || [];
  const coveredSubjects = steps.slice(0, Math.max(3, Math.ceil(steps.length * 0.6))).map((s: any) => s.description);
  const missingSubjects = ['Emergency response procedures', 'Full crew PPE confirmation', 'Verbal confirmation from all workers', ...(steps.length > 3 ? steps.slice(Math.ceil(steps.length * 0.6)).map((s: any) => s.description) : [])];
  return <div className="flex flex-col h-full" data-id="element-1193">
      <div className="mb-6" data-id="element-1194">
        <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-1195">
          Meeting Review
        </h2>
        <p className="text-gray-500" data-id="element-1196">
          Complete AI audit of the safety briefing.
        </p>
      </div>

      <div className="flex-1 overflow-y-auto pb-6 -mx-2 px-2 space-y-8" data-id="element-1197">
        <section data-id="element-1198">
          <h3 className="text-sm font-bold text-gray-500 uppercase tracking-wider mb-3" data-id="element-1199">
            Meeting Overview
          </h3>
          <div className="bg-white border border-gray-200 rounded-xl p-4 grid grid-cols-2 gap-y-4 gap-x-2" data-id="element-1200">
            <div data-id="element-1201">
              <p className="text-xs text-gray-400 uppercase tracking-wider font-semibold mb-1" data-id="element-1202">
                Meeting Type
              </p>
              <p className="text-gray-900 font-medium text-sm" data-id="element-1203">
                PTP Safety Briefing
              </p>
            </div>
            <div data-id="element-1204">
              <p className="text-xs text-gray-400 uppercase tracking-wider font-semibold mb-1" data-id="element-1205">
                Duration
              </p>
              <p className="text-gray-900 font-medium text-sm" data-id="element-1206">04:36</p>
            </div>
            <div data-id="element-1207">
              <p className="text-xs text-gray-400 uppercase tracking-wider font-semibold mb-1" data-id="element-1208">
                Recorded By
              </p>
              <p className="text-gray-900 font-medium text-sm" data-id="element-1209">
                {crewRoles[0]?.role || 'Foreman'}
              </p>
            </div>
            <div data-id="element-1210">
              <p className="text-xs text-gray-400 uppercase tracking-wider font-semibold mb-1" data-id="element-1211">
                Project
              </p>
              <p className="text-gray-900 font-medium text-sm" data-id="element-1212">
                {data.project || 'Project'}
              </p>
            </div>
            <div className="col-span-2" data-id="element-1213">
              <p className="text-xs text-gray-400 uppercase tracking-wider font-semibold mb-1" data-id="element-1214">
                Location
              </p>
              <p className="text-gray-900 font-medium text-sm" data-id="element-1215">
                {data.location || 'Location'}
              </p>
            </div>
          </div>
        </section>

        <section data-id="element-1216">
          <h3 className="text-sm font-bold text-gray-500 uppercase tracking-wider mb-3" data-id="element-1217">
            Participants
          </h3>
          <div className="bg-white border border-gray-200 rounded-xl p-4" data-id="element-1218">
            <ul className="space-y-2 text-sm" data-id="element-1219">
              {crewRoles.map((cr: any, i: number) => <li key={i} className="flex justify-between" data-id="element-1220">
                  <span className="text-gray-900" data-id="element-1221">
                    {cr.name} — {cr.role}
                  </span>
                  <span className={i < crewRoles.length - 2 ? 'text-green-600' : 'text-amber-600'} data-id="element-1222">
                    {i < crewRoles.length - 2 ? 'active' : 'limited participation'}
                  </span>
                </li>)}
              {crewRoles.length === 0 && <li className="text-gray-400 italic" data-id="element-1223">No crew assigned</li>}
            </ul>
          </div>
        </section>

        <section data-id="element-1224">
          <h3 className="text-sm font-bold text-gray-500 uppercase tracking-wider mb-3" data-id="element-1225">
            Subjects Covered
          </h3>
          <div className="bg-white border border-gray-200 rounded-xl p-4" data-id="element-1226">
            <ul className="space-y-2 text-sm" data-id="element-1227">
              {coveredSubjects.map((item: string, i: number) => <li key={i} className="flex items-start gap-2 text-gray-700" data-id="element-1228">
                  <div className="w-1.5 h-1.5 rounded-full bg-green-500 mt-1.5 flex-shrink-0" data-id="element-1229" />
                  {item}
                </li>)}
            </ul>
          </div>
        </section>

        <section data-id="element-1230">
          <h3 className="text-sm font-bold text-gray-500 uppercase tracking-wider mb-3" data-id="element-1231">
            Subjects Missing or Weak
          </h3>
          <div className="bg-white border border-gray-200 rounded-xl p-4" data-id="element-1232">
            <ul className="space-y-2 text-sm" data-id="element-1233">
              {missingSubjects.map((item: string, i: number) => <li key={i} className="flex items-start gap-2 text-gray-700" data-id="element-1234">
                  <div className="w-1.5 h-1.5 rounded-full bg-red-500 mt-1.5 flex-shrink-0" data-id="element-1235" />
                  {item}
                </li>)}
            </ul>
          </div>
        </section>

        <section data-id="element-1236">
          <div className="flex items-center gap-2 mb-3" data-id="element-1237">
            <AlertTriangleIcon className="w-5 h-5 text-yellow-500" data-id="element-1238" />
            <h3 className="text-sm font-bold text-yellow-600 uppercase tracking-wider" data-id="element-1239">
              AI Recommendation
            </h3>
          </div>
          <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-4" data-id="element-1240">
            <p className="text-yellow-700 text-sm leading-relaxed" data-id="element-1241">
              Before work begins, conduct a short follow-up covering the missing
              subjects above and confirm verbal understanding from all crew
              members.
            </p>
          </div>
        </section>

        <section data-id="element-1242">
          <div className="flex items-center gap-2 mb-3" data-id="element-1243">
            <MessageSquareIcon className="w-5 h-5 text-gray-500" data-id="element-1244" />
            <h3 className="text-sm font-bold text-gray-500 uppercase tracking-wider" data-id="element-1245">
              Example Transcript Snippets
            </h3>
          </div>
          <div className="space-y-3" data-id="element-1246">
            {crewRoles.slice(0, 4).map((cr: any, i: number) => {
            const snippets = [`Let's go through the steps. Everyone needs to know their role and the hazards.`, `If conditions change or something doesn't look right, we stop work immediately.`, `I'll make sure my area is clear and equipment is inspected before we start.`, `Communication is key — radio check before we begin each phase.`];
            return <div key={i} className="bg-white border border-gray-200 rounded-xl p-4" data-id="element-1247">
                  <p className="text-xs text-gray-400 uppercase tracking-wider font-semibold mb-1" data-id="element-1248">
                    {cr.role}
                  </p>
                  <p className="text-gray-700 text-sm italic" data-id="element-1249">
                    "{snippets[i % snippets.length]}"
                  </p>
                </div>;
          })}
          </div>
        </section>

        <section data-id="element-1250">
          <h3 className="text-sm font-bold text-gray-500 uppercase tracking-wider mb-3" data-id="element-1251">
            Meeting Quality Score
          </h3>
          <div className="bg-white border border-gray-200 rounded-xl p-4 flex items-center gap-4" data-id="element-1252">
            <div className="text-3xl font-black text-gray-900" data-id="element-1253">
              72<span className="text-lg text-gray-400" data-id="element-1254">/100</span>
            </div>
            <div className="h-8 w-px bg-gray-200" data-id="element-1255" />
            <div className="text-amber-600 font-bold uppercase tracking-wider text-sm" data-id="element-1256">
              Needs Improvement
            </div>
          </div>
        </section>
      </div>

      <div className="sticky bottom-0 z-10 pt-3 pb-2 space-y-3 bg-gray-50" data-id="element-1257">
        <PrimaryButton onClick={onNext} icon={<RefreshCwIcon className="w-5 h-5" data-id="element-1259" />} data-id="element-1258">
          Send Quiz to Crew
        </PrimaryButton>
        <SecondaryButton onClick={onBack} icon={<ArrowLeftIcon className="w-5 h-5" data-id="element-1261" />} data-id="element-1260">
          Back to PTP
        </SecondaryButton>
      </div>
    </div>;
}